import { useSelector } from 'react-redux'
import getText from '../../../shared/i18n/labels'

import { Modal } from 'react-bootstrap'
import { BtnEmpty } from '../../../shared/BtnEmpty'

export function MultiImportModal({ show, onHide, components = [] }) {
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  const renderChildren = () => {
    return components.map((component, index) => {
      return (
        <div key={`col multiimport-${index}`} className="d-flex mb-3 align-items-center">
          {component()}
        </div>
      )
    })
  }

  return (
    <Modal
      backdrop="static"
      show={show}
      size={'lg'}
      aria-labelledby="contained-modal-title-vcenter"
      onHide={onHide}
      centered>
      <div className="bar"></div>
      <Modal.Header closeButton>
        <h2>{labels.IMPORT_RELATIONSHIPS}</h2>
      </Modal.Header>
      <Modal.Body className="row mt-3 flex-column align-content-center">
        {renderChildren()}
      </Modal.Body>
      <Modal.Footer>
        <BtnEmpty text={labels.CANCEL} classCustom="float-start ms-1" handlerOnClick={onHide} />
      </Modal.Footer>
    </Modal>
  )
}
